import { Divider } from '@mui/material'

import { SendStep } from './send-step.component'
import { VerifyStep } from './verify-step.component'

import { useStyles } from '../../styles'
import { E2FAMethod } from 'src/types'

interface IProps {
  method: E2FAMethod | null
}

export const Ematil2FASetup = ({ method }: IProps) => {
  const classes = useStyles()

  if (method === E2FAMethod.Email) {
    return null
  }

  return (
    <div className={classes.tabWrapper}>
      <SendStep />
      <Divider className={classes.divider} />
      <VerifyStep />
    </div>
  )
}
